import { RuleLabel } from '#utils/flags/flagTypes';

export const replaceRuleLabelText = (label: string, ruleLabel: RuleLabel) => {
  let updatedLabel = label;
  if (ruleLabel === RuleLabel.COHORT) {
    updatedLabel = updatedLabel.replace('rule', 'cohort');
    updatedLabel = updatedLabel.replace('Rule', 'Cohort');
  }
  return updatedLabel;
};
